// Shared icon settings for app-level navigation and dashboard UI.
// Keep Lucide icons outline-only by default so future icon tuning is centralized.
export const iconStrokeWidth = 1.75;

export const iconSize = {
  tiny: 12,
  compact: 16,
  menuItem: 18,
  topbar: 20,
  dashboardEmpty: 22,
  dashboardAction: 32,
  dashboardStat: 34,
};

export const hollowIconDefaults = {
  fill: 'none',
  style: { fill: 'none' },
  strokeWidth: iconStrokeWidth,
};
